// @flow

import FileWidget from "./FileWidget";

export default FileWidget;
